module.exports = __webpack_public_path__ + "img/22.c8787df6.svg";